import React from 'react';
import { Card, CardContent } from '../ui/card';

export const StatsRow = ({ stats }) => (
  <div className="grid md:grid-cols-4 gap-6 mb-8">
    <Card>
      <CardContent className="p-6">
        <p className="text-sm text-[#8B7355]/70 mb-2">Total Bookings</p>
        <p className="text-3xl font-bold text-[#8B7355]" data-testid="stats-total">{stats.total}</p>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="p-6">
        <p className="text-sm text-[#8B7355]/70 mb-2">Pending</p>
        <p className="text-3xl font-bold text-yellow-600" data-testid="stats-pending">{stats.pending}</p>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="p-6">
        <p className="text-sm text-[#8B7355]/70 mb-2">Deposit Paid</p>
        <p className="text-3xl font-bold text-green-600" data-testid="stats-deposit-paid">{stats.depositPaid}</p>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="p-6">
        <p className="text-sm text-[#8B7355]/70 mb-2">Total Revenue</p>
        <p className="text-3xl font-bold text-[#C9A961]" data-testid="stats-revenue">
          ${stats.totalRevenueFormatted}
        </p>
      </CardContent>
    </Card>
  </div>
);
